import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import cogoToast from "cogo-toast";
import { BACKEND_URL } from "../constants"


const ChangePasword = () => {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading]= useState(false)
  const navigate = useNavigate()
  const user = JSON.parse(sessionStorage.getItem("user"));
  console.log(user.user,"user")

  const onChange = (e) => {
    if(e.target.name == "email"){
      setEmail(e.target.value);
    }
    else{
      setPassword(e.target.value);
    }
  };

  const updatePassword = async () => {
    try{
      const response = await fetch(`${BACKEND_URL}/changePassword`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id: user.user.userId,
        email: email,
        password: password
      }),
    });
    const result = await response.json();

    if (result.statusCode === 200) {
      setLoading(false)
      cogoToast.success(
        "Hasło zostało pomyślnie zmienione"
      );
      navigate("/");
    } else {
      cogoToast.error("Nieprawidłowe dane");
    } 
  }
  catch (error) {
    console.error("erorr: ", error);
  }}
  return (
    <>
      <div className="login-user-container">
        <div className="login-user-box">
          {/* <div className="login-user-header">
            <p className="login-user-header-text">Dodaj nowy banner</p>
          </div> */}
          <div className="login-user-placeholder">
            <div style={{display:"flex", paddingTop:"50px", marginBottom:"20px", justifyContent:"center", alignItems:'center', flexFlow:"column"}} class="form-group">
              <label for="exampleInputEmail1">Wpisz stary E-mail</label>
               <input style={{padding:"10px", width:"20%", textAlign:"center"}} name="email" type="email" placeholder="Dodaj E-mail" onChange={onChange} className="form-control"/>
               <label for="exampleInputEmail1">Wpisz nowe hasło</label>
               <input style={{padding:"10px", width:"20%", textAlign:"center"}} name="password" type="password" placeholder="Dodaj nowe hasło" onChange={onChange} className="form-control"/>
            </div>
          </div>
          <button className="btn btn-primary"  style={{marginBottom:"50px"}} onClick={updatePassword}>
            Zmień hasło
          </button>
        </div>
      </div>
    </>
  );
};
export default ChangePasword;
